import { render, staticRenderFns } from "./OrdersSettings.vue?vue&type=template&id=5d5540f2&"
import script from "./OrdersSettings.vue?vue&type=script&lang=js&"
export * from "./OrdersSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports